import { Union } from "../Docs/fable_modules/fable-library.3.7.1/Types.js";
import { array_type, class_type, unit_type, int32_type, bool_type, list_type, obj_type, lambda_type, string_type, union_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class ColumnResizeMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChange", "OnEnd"];
    }
}

export function ColumnResizeMode$reflection() {
    return union_type("Feliz.TanStack.Table.Types.ColumnResizeMode", [], ColumnResizeMode, () => [[], []]);
}

export class ColumnDefOptionProp$1 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Id", "AccessorKey", "AccessorFn", "HeaderStr", "HeaderFn", "FooterStr", "FooterFn", "Cell", "AggregatedCell", "Columns", "AggregationFnOption", "EnableGrouping", "Size", "MinSize", "MaxSize", "EnableHiding", "SortingFn", "SortDescFirst", "EnableSorting", "EnableMultiSort", "InvertSorting", "SortUndefined"];
    }
}

export function ColumnDefOptionProp$1$reflection(gen0) {
    return union_type("Feliz.TanStack.Table.Types.ColumnDefOptionProp`1", [gen0], ColumnDefOptionProp$1, () => [[["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(gen0, string_type)]], [["Item", string_type]], [["Item", obj_type]], [["Item", string_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [["Item", list_type(list_type(ColumnDefOptionProp$1$reflection(gen0)))]], [["Item", obj_type]], [["Item", bool_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", bool_type]], [["Item", obj_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", obj_type]]]);
}

export class Aggregation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Sum", "Min", "Max", "Extent", "Mean", "Median", "Unique", "UniqueCount", "Count", "Auto"];
    }
}

export function Aggregation$reflection() {
    return union_type("Feliz.TanStack.Table.Types.Aggregation", [], Aggregation, () => [[], [], [], [], [], [], [], [], [], []]);
}

export class AggregationFnOption$1 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Aggregation", "AggregationFn"];
    }
}

export function AggregationFnOption$1$reflection(gen0) {
    return union_type("Feliz.TanStack.Table.Types.AggregationFnOption`1", [gen0], AggregationFnOption$1, () => [[["Item", Aggregation$reflection()]], [["Item", lambda_type(lambda_type(unit_type, array_type(class_type("Feliz.TanStack.Table.Types.Row`1", [gen0]))), lambda_type(lambda_type(unit_type, class_type("Feliz.TanStack.Table.Types.Row`1", [gen0])), obj_type))]]]);
}

export class SortDirection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Asc", "Desc", "NotSorted"];
    }
}

export function SortDirection$reflection() {
    return union_type("Feliz.TanStack.Table.Types.SortDirection", [], SortDirection, () => [[], [], []]);
}

export function ColumnResizeMode_toString_21C97CDE(resizeMode) {
    if (resizeMode.tag === 1) {
        return "onEnd";
    }
    else {
        return "onChange";
    }
}

export function Aggregation__asString(this$) {
    switch (this$.tag) {
        case 1: {
            return "min";
        }
        case 2: {
            return "max";
        }
        case 3: {
            return "extent";
        }
        case 4: {
            return "mean";
        }
        case 5: {
            return "median";
        }
        case 6: {
            return "unique";
        }
        case 7: {
            return "uniqueCount";
        }
        case 8: {
            return "count";
        }
        case 9: {
            return "auto";
        }
        default: {
            return "sum";
        }
    }
}

//# sourceMappingURL=Types.fs.js.map
